import { useMemo } from 'react';
import { api } from '../redux/api';
import { useGetClientId } from './clientId';

/**
 * Returns whether to open Telegram instead of showing the contacts modal (phone)
 * when user taps "Contact us". Uses the last charging session's port from history:
 * if that port has maxPowerWt < 30 kW, prefer Telegram (do not show phone).
 */
export function useContactUsTelegramPreferred() {
  const { clientId } = useGetClientId();
  const { data: historyData } = api.useGetHistoryDataQuery(clientId, { skip: !clientId });

  const lastChargingSession = useMemo(() => {
    if (!historyData?.length) return null;
    const sorted = [...historyData].sort(
      (a, b) => new Date(b.startedOn || b.createdOn) - new Date(a.startedOn || a.createdOn)
    );
    return sorted.find(item => item.plugNumber && item.state !== 'TOP_UP_BALANCE') ?? sorted[0];
  }, [historyData]);

  const lastPlugNumber = lastChargingSession?.plugNumber ?? null;

  const { data: lastPortStation } = api.useGetDeviceStationQuery(
    { stationNumber: lastPlugNumber, lat: 0, lon: 0 },
    { skip: !lastPlugNumber }
  );

  const preferTelegram = Boolean(lastPortStation?.maxPowerWt != null && lastPortStation.maxPowerWt < 30000);

  return { preferTelegram, lastPortForLink: lastPlugNumber };
}
